import React from "react";
import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { theme } from "src/config";
import styled from "styled-components";
import { Spacer, Text } from ".";
import { Item } from "src/models";
import { ItemStores } from "src/stores";
import { Card, CardGrid } from "src/views";
import { DataType, ItemType, IItem } from "src/types";

export interface IItemListProps {
  itemStores?: ItemStores;
  items?: Item<IItem>[];
  date?: string;
}

export const ItemList = inject(
  "itemStores",
)(
  observer((props: IItemListProps) => {
    const { itemStores, items, date } = props;

    const { t, i18n } = useTranslation();
    const type = items.length ? items[0].data_type : '' as ItemType;
    return (
      <SidebarInnerContainer>
        <SidebarHeader>
          <Text color="grayDarkest" size="large" weight="bold">
            {t(type+'_plural')}
          </Text>
          <Spacer size="medium" />
          <Text color="grayDarkest" size="large" weight="thin">
            {(date||'').toString()}
          </Text>
        </SidebarHeader>
        <StyledCardGrid>
          {items?.map((i: Item<IItem>) => (
            <Card
              key={i.id}
              data={i}
              onClick={() => itemStores[type as ItemType].setActive(i)}
              type={type}
            />
          ))}
        </StyledCardGrid>
      </SidebarInnerContainer>
    );
  })
);

const SidebarInnerContainer = styled.div`
  margin: 2rem 2rem;
  z-index: 100;
`;

const SidebarHeader = styled.div`
  display: flex;
  border-bottom: 1px solid ${theme.color.secondaryBorder};
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
`;

const StyledCardGrid = styled(CardGrid)`
  padding:         2rem 0rem;
  overflow-y:      visible;
  justify-content: flex-start;
`;


